import React, { useState } from "react";

export default function Textarea({ input, onUpdate, value = "" }: any) {
    const [hasInput, setHasInput] = useState(false);
    const textareaId = input.id ? String(input.id) : input.name;

    const handleInputChange = (event: any) => {
        setHasInput(event.target.value !== "");
        onUpdate(event.target.name, event.target.value);
    };

    return (
        <div className="relative w-full group sm:px-4">
            <label htmlFor={textareaId} className="sr-only">
                {input.label || input.placeholder}
            </label>
            <textarea
                className="bg-transparent border-[1px] border-white w-full resize-none outline-none rounded-2xl px-4 py-1 placeholder:text-white placeholder:opacity-70"
                rows={5}
                name={input.name}
                id={textareaId}
                required
                defaultValue={value}
                onChange={handleInputChange}
                placeholder={input.placeholder}
            />
        </div>
    );
}
